<template>
  <layout>
    <span slot="header">{{ title }}<button class="btn-pop-close delete" aria-label="close" @click="closeModal"></button></span>
    <div slot="content">
      <div class="table-header">
        <el-form size="mini" @submit.prevent>
          <el-row :gutter="24">
            <el-col :span="10">
              <el-form-item label="정산년월" label-width="80px">
                <el-col :span="14">
                  <el-date-picker type="month" placeholder="정산년월" v-model="procForm.yearMonth" style="width: 90%;" value-format="yyyy-MM" :picker-options="pickerOptions" @change="goOpenSub()"></el-date-picker>
                </el-col>
              </el-form-item>
            </el-col>
            <el-col :span="14">
              <el-form-item>
                <el-button type="primary" icon="el-icon-search" style="float: right;margin-left: 10px;" v-show="btnSearchShow" @click="goOpen()">검색</el-button>
                <el-button type="primary" icon="el-icon-document-add" style="float: right;" v-show="btnSquareSelectedShow" @click="btnSquareProc('Y')">선택정산</el-button>
                <el-button type="warning" icon="el-icon-document-copy" style="float: right;" v-show="btnSquareAllShow" @click="btnSquareAll()">전체정산</el-button>
                <el-button type="primary" icon="el-icon-check" style="float: right;" @click="btnSquareView()">정산금액보기</el-button>
                <el-button type="danger" icon="el-icon-delete-solid" style="float: right;" v-show="btnSquareCancelShow" @click="btnSquareProc('N')">정산취소</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="pop-content-search">
        <el-form size="mini" @submit.prevent>
          <el-row :gutter="24">
            <el-col :span="14">
              <el-form-item label="처리기간" label-width="80px">
                <el-col :span="11">
                  <el-date-picker type="date" placeholder="시작일" v-model="form.startDt" style="width: 90%;" value-format="yyyy-MM-dd"></el-date-picker>
                </el-col>
                <el-col :span="1" style="text-align: center;">-</el-col>
                <el-col :span="11">
                  <el-date-picker type="date" placeholder="종료일" v-model="form.endDt" style="width: 90%;" value-format="yyyy-MM-dd"></el-date-picker>
                </el-col>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="정산구분" label-width="100px">
                <el-select v-model="form.squareYn">
                  <el-option value='' label="전체">전체</el-option>
                  <el-option
                      v-for="item in combos['squareYn']"
                      :key="item.value"
                      :value="item.key"
                      :label="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="14">
              <el-form-item label="지역/센터" label-width="80px">
                <el-col :span="24">
                  <el-select v-model="form.catId" @change="onCatIdChange">
                    <el-option value='' label="전체">전체</el-option>
                    <el-option
                        v-for="item in combos['catId']"
                        :key="item.key"
                        :value="item.key"
                        :label="item.value">
                    </el-option>
                  </el-select>
                  <el-select v-model="form.subCatId" v-show="changeCatIdShow">
                    <el-option value='' label="전체">전체</el-option>
                    <el-option
                        v-for="item in combos['subCatId']"
                        :key="item.key"
                        :value="item.key"
                        :label="item.value">
                    </el-option>
                  </el-select>
                </el-col>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="처리유형" label-width="100px">
                <el-select v-model="form.squareType">
                  <el-option value='' label="전체">전체</el-option>
                  <el-option
                      v-for="item in combos['squareType']"
                      :key="item.value"
                      :value="item.key"
                      :label="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>

      <div class="grid-wrap">
        <div class="table-area">
          <div class="table-b">
            <ag-grid-vue
                style="width: 100%; height: 330px;"
                class="ag-theme-alpine"
                :framework-components="frameworkComponents"
                :column-defs="columnDefs"
                :grid-options="gridOptions"
                :row-data="rowData"
                :context="context"
                :default-col-def="defaultColDef"
                :statusBar="statusBar"
                :enableRangeSelection="true"
                @cell-clicked="onCellClicked"
                @grid-ready="onGridReady"/>
          </div>
        </div>
      </div>
      <div class="grid-wrap">
        <div class="table-area">
          <div class="table-b">
            <ag-grid-vue
                style="width: 100%; height: 250px;"
                class="ag-theme-alpine"
                :framework-components="frameworkComponents"
                :column-defs="subColumnDefs"
                :grid-options="subGridOptions"
                :row-data="subRowData"
                :default-col-def="defaultColDef"
                :enableRangeSelection="true"
                @grid-ready="onGridReady"/>
          </div>
        </div>
      </div>
    </div>
  </layout>
</template>


<script>
/**
* * components
*/
import Layout from '@/components/Slot/ModalSlot.vue';
import mixin from "@/mixin/lucoms";

import {AgGridVue} from 'ag-grid-vue';
import CheckboxCellRenderer from "@/components/agGrid/checkbox-cell-renderer";
import ReceptionModal from "@/components/AS/CallDispose/Modal/ReceptionModal";
import BsMaTreat from "@/components/AS/BsmaList/BsMaTreat";
import InstallTreat from "@/components/AS/InstallList/InstallTreat";

function _url(...args) {
  args = args.map(x => String(x || '').trim().replace(/^\/*|\/*$/g, ''))
  args = args.filter(x => x)
  return args.join('/')
}

export default {
  mixins: [mixin],
  props: {
    data: {
      Type: Object
      , required: false
    },
  },
  components: {Layout, AgGridVue},
  data() {
    return {
      title: '센터별정산',
      form: {
        companyId : 'CENTERLINK',
        startDt: this.$moment().subtract(1, 'months').add(1, 'days').format('YYYY-MM-DD'),
        endDt: this.$moment().format('YYYY-MM-DD'),
        squareYn : '',            // 정산구분
        squareType : '',          // 처리유형
        catId : '',               // 지역
        subCatId: '',             // 지역 상세
        sortType : '',            // 승인/정산처리유형
        page : 1,
        totalPage : 99999,
        curPage : 0,
        totalCount : 99999,
        processTime : '',
      },
      procForm: {
        yearMonth: this.$moment().format('YYYY-MM-DD')
      },
      combos: {
        'itemGroup' : [],
        'catId' : [],
        'subCatId' : [],
        'squareYn' : [],
        'squareType' : [],
      },
      // todo 버튼 임시 show
      // btnSearchShow : false,
      // btnSquareCancelShow : false,
      // btnSquareAllShow : false,
      // btnSquareSelectedShow : false,
      btnSearchShow : true,
      btnSquareCancelShow : true,
      btnSquareAllShow : true,
      btnSquareSelectedShow : true,


      changeCatIdShow : true,
      // AG-GRID OPTION [START]
      rowData:[],
      subRowData:[],
      rowDataOrg:[], /** 조회후 데이타 백업 */
      gridOptions: {},
      subGridOptions: {},
      frameworkComponents : {
        checkBox: CheckboxCellRenderer,
      },
      context: {
        //checkbox 전체 체크 이벤트 추가
        headerAllCheckEvent: this.allCheckEvnet
      },
      pickerOptions: {
        format: 'yyyy-MM',
      },
      statusBar: null,
      columnDefs:[
        {
          headerName:'No',
          field:'no',
          width:80,
          cellStyle:{textAlign: 'center'},
          valueFormatter: function(params) {
            return params.node.rowIndex+1;
          }
        },
        {
          field: 'chk',
          width: 80,
          headerComponent: `checkBox`,
          headerComponentParams: (params) => {
            return params;
          },
          cellRenderer: 'checkBox'
        },
        {headerName:'센터명', field:'asAgentNm', width:130, cellStyle : {textAlign: 'left'},
          cellRenderer: (params) => {
            return `<div style="text-decoration: underline; text-underline-position: under; color:blue; cursor:pointer;">${params.value}</div>`;
          }},
        {headerName:'처리일자', field:'procDt', width:140, cellStyle : {textAlign: 'center'},
        valueFormatter: (params) => {
          return this.$moment(params.value).format('YYYY-MM-DD');
        }},
        {headerName:'정산구분', field:'squareYnNm', width:120},
        {headerName:'처리유형', field:'squareTypeNm', width:120},
        {headerName:'접수번호', field:'squareId', width:180, cellStyle : {textAlign: 'center'}},
        {headerName:'처리자', field:'userNm', width:130},
        {
          headerName: 'A/S',
          children: [
            {
              headerName: '유상',
              children: [
                {headerName:'자재비', field:'inAsItemUnitAmt', width:120, cellStyle:{textAlign: 'right'},
                  valueFormatter: (params) => {
                    return this.getNumberFormat(params.value);
                  }},
                {headerName:'이관비', field:'inAsCallUnitAmt', width:120, cellStyle:{textAlign: 'right'},
                  valueFormatter: (params) => {
                    return this.getNumberFormat(params.value);
                  }},
                {headerName:'대수', field:'inAsQty', width:120, cellStyle:{textAlign: 'right'},
                  valueFormatter: (params) => {
                    return this.getNumberFormat(params.value);
                  }},
                {headerName:'합계', field:'inAsAmt', width:120, cellStyle:{textAlign: 'right'},
                  valueFormatter: (params) => {
                    return this.getNumberFormat(params.value);
                  }},
              ]
            },
            {
              headerName: '무상',
              children: [
                {headerName:'기본비', field:'outAsUnitPrice1', width:120, cellStyle:{textAlign: 'right'},
                  valueFormatter: (params) => {
                    return this.getNumberFormat(params.value);
                  }},
                {headerName:'원거리출장비', field:'outAsEtcPrice1', width:120, cellStyle:{textAlign: 'right'},
                  valueFormatter: (params) => {
                    return this.getNumberFormat(params.value);
                  }},
                {headerName:'기타비용', field:'outAsEtcPrice2', width:120, cellStyle:{textAlign: 'right'},
                  valueFormatter: (params) => {
                    return this.getNumberFormat(params.value);
                  }},
                {headerName:'대수', field:'outAsQty', width:120, cellStyle:{textAlign: 'right'},
                  valueFormatter: (params) => {
                    return this.getNumberFormat(params.value);
                  }},
                {headerName:'합계', field:'outAsAmt', width:120, cellStyle:{textAlign: 'right'},
                  valueFormatter: (params) => {
                    return this.getNumberFormat(params.value);
                  }},
              ]
            }
          ],
        },
        {
          headerName: 'BS/MA',
          children: [
            {headerName:'처리비', field:'outBsmaUnitPrice1', width:120, cellStyle:{textAlign: 'right'},
              valueFormatter: (params) => {
                return this.getNumberFormat(params.value);
              }},
            {headerName:'원거리출장비', field:'outBsmaEtcPrice1', width:120, cellStyle:{textAlign: 'right'},
              valueFormatter: (params) => {
                return this.getNumberFormat(params.value);
              }},
            {headerName:'기타비용', field:'outBsmaEtcPrice2', width:120, cellStyle:{textAlign: 'right'},
              valueFormatter: (params) => {
                return this.getNumberFormat(params.value);
              }},
            {headerName:'대수', field:'outBsmaQty', width:120, cellStyle:{textAlign: 'right'},
              valueFormatter: (params) => {
                return this.getNumberFormat(params.value);
              }},
            {headerName:'합계', field:'outBsmaAmt', width:120, cellStyle:{textAlign: 'right'},
              valueFormatter: (params) => {
                return this.getNumberFormat(params.value);
              }},
          ]
        },
        {
          headerName: '설치',
          children: [
            {headerName:'설치비1', field:'outSetupUnitPrice1', width:120, cellStyle:{textAlign: 'right'},
              valueFormatter: (params) => {
                return this.getNumberFormat(params.value);
              }},
            {headerName:'설치비2', field:'outSetupUnitPrice2', width:120, cellStyle:{textAlign: 'right'},
              valueFormatter: (params) => {
                return this.getNumberFormat(params.value);
              }},
            {headerName:'원거리출장비', field:'outSetupEtcPrice1', width:120, cellStyle:{textAlign: 'right'},
              valueFormatter: (params) => {
                return this.getNumberFormat(params.value);
              }},
            {headerName:'기타비용', field:'outSetupEtcPrice2', width:120, cellStyle:{textAlign: 'right'},
              valueFormatter: (params) => {
                return this.getNumberFormat(params.value);
              }},
            {headerName:'대수', field:'outSetupQty', width:120, cellStyle:{textAlign: 'right'},
              valueFormatter: (params) => {
                return this.getNumberFormat(params.value);
              }},
            {headerName:'합계', field:'outSetupAmt', width:120, cellStyle:{textAlign: 'right'},
              valueFormatter: (params) => {
                return this.getNumberFormat(params.value);
              }},
          ],
        },
        {
          headerName: '합계',
          children: [
            {headerName:'대수', field:'outSetupQty', width:120, cellStyle:{textAlign: 'right'},
              valueGetter: (params) => {
                return this.getNumberFormat(params.data.outSetupQty + params.data.outBsmaQty + params.data.outAsQty + params.data.inAsQty)
              }},
            {headerName:'합계', field:'outSetupAmt', width:120, cellStyle:{textAlign: 'right'},
              valueGetter: (params) => {
                return this.getNumberFormat(params.data.outSetupAmt + params.data.outBsmaAmt + params.data.outAsAmt - params.data.inAsAmt)
              }},
          ]
        }
      ],
      subColumnDefs:[
        {
          headerName:'No',
          field:'no',
          width:80,
          cellStyle:{textAlign: 'center'},
          valueFormatter: function(params) {
            return params.node.rowIndex+1;
          }
        },
        {headerName:'정산여부', field:'squareYn', width:130, cellStyle : {textAlign: 'center'},
          valueGetter: (params) => {
            return params.data.squareYn === 'Y' ? "정산 소계" : "미정산 소계"
          }
        },
        {
          headerName: 'A/S',
          children: [
            {
              headerName: '유상',
              children: [
                {headerName:'자재비', field:'inAsItemUnitAmt', width:120, cellStyle:{textAlign: 'right'},
                  valueFormatter: (params) => {
                    return this.getNumberFormat(params.value);
                  }},
                {headerName:'이관비', field:'inAsCallUnitAmt', width:120, cellStyle:{textAlign: 'right'},
                  valueFormatter: (params) => {
                    return this.getNumberFormat(params.value);
                  }},
                {headerName:'대수', field:'inAsQty', width:120, cellStyle:{textAlign: 'right'},
                  valueFormatter: (params) => {
                    return this.getNumberFormat(params.value);
                  }},
                {headerName:'합계', field:'inAsAmt', width:120, cellStyle:{textAlign: 'right'},
                  valueFormatter: (params) => {
                    return this.getNumberFormat(params.value);
                  }},
              ]
            },
            {
              headerName: '무상',
              children: [
                {headerName:'기본비', field:'outAsUnitPrice1', width:120, cellStyle:{textAlign: 'right'},
                  valueFormatter: (params) => {
                    return this.getNumberFormat(params.value);
                  }},
                {headerName:'원거리출장비', field:'outAsEtcPrice1', width:120, cellStyle:{textAlign: 'right'},
                  valueFormatter: (params) => {
                    return this.getNumberFormat(params.value);
                  }},
                {headerName:'기타비용', field:'outAsEtcPrice2', width:120, cellStyle:{textAlign: 'right'},
                  valueFormatter: (params) => {
                    return this.getNumberFormat(params.value);
                  }},
                {headerName:'대수', field:'outAsQty', width:120, cellStyle:{textAlign: 'right'},
                  valueFormatter: (params) => {
                    return this.getNumberFormat(params.value);
                  }},
                {headerName:'합계', field:'outAsAmt', width:120, cellStyle:{textAlign: 'right'},
                  valueFormatter: (params) => {
                    return this.getNumberFormat(params.value);
                  }},
              ]
            }
          ],
        },
        {
          headerName: 'BS/MA',
          children: [
            {headerName:'처리비', field:'outBsmaUnitPrice1', width:120, cellStyle:{textAlign: 'right'},
              valueFormatter: (params) => {
                return this.getNumberFormat(params.value);
              }},
            {headerName:'원거리출장비', field:'outBsmaEtcPrice1', width:120, cellStyle:{textAlign: 'right'},
              valueFormatter: (params) => {
                return this.getNumberFormat(params.value);
              }},
            {headerName:'기타비용', field:'outBsmaEtcPrice2', width:120, cellStyle:{textAlign: 'right'},
              valueFormatter: (params) => {
                return this.getNumberFormat(params.value);
              }},
            {headerName:'대수', field:'outBsmaQty', width:120, cellStyle:{textAlign: 'right'},
              valueFormatter: (params) => {
                return this.getNumberFormat(params.value);
              }},
            {headerName:'합계', field:'outBsmaAmt', width:120, cellStyle:{textAlign: 'right'},
              valueFormatter: (params) => {
                return this.getNumberFormat(params.value);
              }},
          ]
        },
        {
          headerName: '설치',
          children: [
            {headerName:'설치비1', field:'outSetupUnitPrice1', width:120, cellStyle:{textAlign: 'right'},
              valueFormatter: (params) => {
                return this.getNumberFormat(params.value);
              }},
            {headerName:'설치비2', field:'outSetupUnitPrice2', width:120, cellStyle:{textAlign: 'right'},
              valueFormatter: (params) => {
                return this.getNumberFormat(params.value);
              }},
            {headerName:'원거리출장비', field:'outSetupEtcPrice1', width:120, cellStyle:{textAlign: 'right'},
              valueFormatter: (params) => {
                return this.getNumberFormat(params.value);
              }},
            {headerName:'기타비용', field:'outSetupEtcPrice2', width:120, cellStyle:{textAlign: 'right'},
              valueFormatter: (params) => {
                return this.getNumberFormat(params.value);
              }},
            {headerName:'대수', field:'outSetupQty', width:120, cellStyle:{textAlign: 'right'},
              valueFormatter: (params) => {
                return this.getNumberFormat(params.value);
              }},
            {headerName:'합계', field:'outSetupAmt', width:120, cellStyle:{textAlign: 'right'},
              valueFormatter: (params) => {
                return this.getNumberFormat(params.value);
              }},
          ],
        },
        {
          headerName: '합계',
          children: [
            {headerName:'대수', field:'outSetupQty', width:120, cellStyle:{textAlign: 'right'},
              valueGetter: (params) => {
                return this.getNumberFormat(params.data.outSetupQty + params.data.outBsmaQty + params.data.outAsQty + params.data.inAsQty)
              }},
            {headerName:'합계', field:'outSetupAmt', width:120, cellStyle:{textAlign: 'right'},
              valueGetter: (params) => {
                return this.getNumberFormat(params.data.outSetupAmt + params.data.outBsmaAmt + params.data.outAsAmt - params.data.inAsAmt)
              }
            },
          ]
        }
      ],
      defaultColDef: {
        resizable: true,
        filter:true,
        sortable: true
      },
      // AG-GRID OPTION [END]
    }
  },
  created(){
    this.isAuth()

    this.statusBar = {
      statusPanels: [
        { statusPanel: 'agTotalRowCountComponent', align: 'right' },
      ],
    };
  },
  mounted() {
    this.getCombo()
    this.getConfigValue()
  },
  destroyed() {
  },
  methods: {
    closeModal() {
      this.$parent.close();
    },
    handleNodeClick(data) {
    },
    onGridReady(){

    },
    getCombo() {
      this.getSquareYnCombo();
      this.getCatIdCombo();
      this.getSquareTypeCombo();
    },
    getConfigValue() {
      this.$http.get(`/api/config/keyPath/info`, {params: {keyPath: 'System.MainAsAgentId'}})
          .then(response => {
            this.form.asAgentId = response.data[0].configValue;
          });
    },
    getCatIdCombo(){
      this.$store.commit('loading')
      this.$http.get(`/api/codeMng/detail`, { params: {catKey: this.data.asAgentId} })
          .then(response => {
            let vCatId = response.data[0].parentId
            let vSubCatId = response.data[0].catId
            // 지역 상세값 세팅
            this.$http.get(`/api/codeMng/combo/catId`, { params: {parentId: response.data[0].parentId} })
                .then(response => {
                  this.combos['subCatId'] = response.data || []
                  // 지역 값 세팅
                  this.$http.get(`/api/codeMng/combo/catId`, { params: {parentId: 217} })
                      .then(response => {
                        this.combos['catId'] = response.data || []
                        this.form.subCatId = vSubCatId.toString()
                        this.form.catId = vCatId.toString()
                      });
                });
          }).finally(() => {
        this.$store.commit('finish')
      });
    },
    getSquareYnCombo(){
      this.$http.get(`/api/codeMng/combo`, { params: {parentId: 258} })
          .then(response => {
            this.combos['squareYn'] = response.data || []
          });
    },
    getSquareTypeCombo(){
      this.$http.get(`/api/codeMng/combo`, { params: {parentId: 389} })
          .then(response => {
            this.combos['squareType'] = response.data || []
          });
    },
    onCatIdChange(param){
      this.form.subCatId = '';
      if(param === '') this.changeCatIdShow =  false;
      else{
        this.changeCatIdShow =  true;
        // 지역 상세
        this.$http.get(`/api/codeMng/combo/catId`, { params: {parentId: param} })
            .then(response => {
              this.combos['subCatId'] = response.data || []
            });
      }
    },
    goOpen(){
      this.$store.commit('loading')

      const vform = {
        companyId : this.form.companyId,
        startDt : this.form.startDt,
        endDt : this.form.endDt,
        squareYn : this.form.squareYn,
        squareType : this.form.squareType,
        catId : (this.form.subCatId.length <= 0 || this.form.subCatId === '')  ? (this.form.catId === '' ? 0 : this.form.catId) : this.form.subCatId,     // 지역
        sortType : this.form.sortType,         // 승인/정산처리유형
        page : 1,
        totalPage : 99999,
        curPage : 0,
        totalCount : 99999,
        processTime : ''
      }

      this.$http.post(_url("/api/workMng/calculation/square/list"), vform)
          .then(response => {
            this.rowData = response.data
            this.goOpenSub();
            /* data customize */
            this.changeData();
          }).finally(() => {
            this.$store.commit('finish')
      });
    },
    goOpenSub(){

      const vSubForm = {
        companyId : this.form.companyId,
        startDt : this.form.startDt,
        endDt : this.form.endDt,
        squareYymm : this.procForm.yearMonth.replace(/-/gi, '').substring(0, 6),
        squareType : '',
        catId : (this.form.subCatId.length <= 0 || this.form.subCatId === '')  ? (this.form.catId === '' ? 0 : this.form.catId) : this.form.subCatId,     // 지역
        squareId : ''
      }

      this.$http.post(_url(`/api/workMng/calculation/squareTotal/list`), vSubForm)
          .then((subResponse) => {
            this.subRowData = subResponse.data
          })
    },
    // 선택정산, 정산취소
    btnSquareProc(status) {
      let vm = this;
      var txtQuestion;
      var txtSuccess;
      var txtFail;

      if(status === 'Y') {
        txtQuestion = '선택한 항목을 정산 하시겠습니까?'
        txtSuccess = '정산되었습니다.'
        txtFail = '정산할 항목을 선택하세요.'
      } else {
        txtQuestion = '선택한 항목을 정산취소 하시겠습니까?'
        txtSuccess = '정산취소되었습니다.'
        txtFail = '정산취소할 항목을 선택하세요.'
      }

      const result = this.rowData.filter(v => v.chk === 'Y').map(x => {
        x.yesNo = status
        x.squareYymm = this.procForm.yearMonth.replace(/-/gi, '').substring(0, 6)
        return x
      });

      if(result.length > 0){
        this.$swal({
          type: 'question',
          text: txtQuestion,
          showCancelButton: true
        }).then(r => {
          if (r.value) {
            this.$store.commit('loading')
            this.$http.post(_url(`/api/workMng/calculation/squareProc`), result)
                .then((response) => {
                  this.$swal({ type: 'success', text: txtSuccess })
                      .then((result) => {
                        if (result.value) this.goOpen();
                      });
                }).catch((e) => {
              this.$swal({ type: 'warning', text: '실패되었습니다' })
            }).finally(() => {
              this.$store.commit('finish')
            });
          }
        })
      } else {
        this.$swal({ type: 'info', text: txtFail });
      }
    },
    btnSquareCancel(){
      let list = this.rowData.filter(v => v.chk === 'Y')
      const vform = {
        companyId : this.form.companyId,
        startDt : this.form.startDt,
        endDt : this.form.endDt,
        squareYymm : this.procForm.yearMonth.replace(/-/gi, '').substring(0, 6),
        squareType : '',
        catId : (this.form.subCatId.length <= 0 || this.form.subCatId === '')  ? (this.form.catId === '' ? 0 : this.form.catId) : this.form.subCatId,     // 지역  //this.data.asAgentId,
        squareId : list.map(x => {return x.squareId;}).join(',')
      }

    },
    btnSquareView(){
      let list = this.rowData.filter(v => v.chk === 'Y')
      const vform = {
        companyId : this.form.companyId,
        startDt : this.form.startDt,
        endDt : this.form.endDt,
        squareYymm : this.procForm.yearMonth.replace(/-/gi, '').substring(0, 6),
        squareType : '',
        catId : (this.form.subCatId.length <= 0 || this.form.subCatId === '')  ? (this.form.catId === '' ? 0 : this.form.catId) : this.form.subCatId,     // 지역 //this.data.asAgentId,
        squareId : list.map(x => {return x.squareId;}).join(',')
      }

      if(list.length > 0){
        this.$swal({
          type: 'question',
          text: '정산금액보기 하시겠습니까?',
          showCancelButton: true
        }).then(r => {
          if (r.value) {
            this.$store.commit('loading')
            this.$http.post(_url(`/api/workMng/calculation/squareTotal/list`), vform)
                .then((response) => {
                  this.$swal({ type: 'success', text: '처리되었습니다.' })
                      .then((result) => {
                        if (result.value) {
                          this.subRowData = response.data
                          //this.goOpen();
                        }
                      });
                })
                .catch((e) => {
                  this.$swal({ type: 'success', text: '정산금액보기를 실패 했습니다.' })
                })
                .finally(() => {
                  this.$store.commit('finish')
                });
          }
        })
      } else {
        this.$swal({ type: 'info', text: '정산금액보기를 처리할 항목을 선택하세요.' });
      }
    },
    isAuth(){
      this.auth = this.$store.state.loginInfo.authorities.filter(x=>x.programId===239); // 센터별정산 팝업
      const auth = this.auth
      if(auth && auth.length > 0){
        this.btnSearchShow = auth[0].grantSelect === 'Y' ? true : false;
        this.btnSquareCancelShow = auth[0].grantExtend1 === 'Y' ? true : false;
        this.btnSquareAllShow = auth[0].grantExtend2 === 'Y' ? true : false;
        this.btnSquareSelectedShow = auth[0].grantExtend3 === 'Y' ? true : false;
      }
    },
    btnSquareAll() {
      let vm = this;

      this.$swal({
        type: 'question',
        text: '전체정산 하시겠습니까?',
        showCancelButton: true,
        confirmButtonText: '예',
        cancelButtonText: '아니오',
      }).then(r => {
        if (r.value) {
          vm.$store.commit('loading')

          const vform = {
            companyId: this.$store.state.loginInfo.compCd,
            squareYymm: this.procForm.yearMonth.replace(/-/gi, '').substring(0, 6)
          }

          this.$http.post(_url(`/api/workMng/calculation/squareTotalProc`), vform)
              .then((response) => {
                this.$swal({ type: 'success', text: '전체정산 완료되었습니다.' })
                    .then((result) => {
                      if (result.value) {
                        this.goOpen();
                      }
                    });
              })
              .catch((e) => {
                this.$swal({ type: 'success', text: '실패되었습니다.' })
              })
              .finally(() => {
                vm.$store.commit('finish')
              });
        }
      }).catch((e) => {
      })

    },
    /* data customize */
    changeData(){
      this.rowData.map((x, i) => {
        //정산구분
        let filterSquareYn = this.combos['squareYn'].filter(y => y.key === x.squareYn);
        x.squareYnNm = filterSquareYn[0].value;
        //처리유형
        let filterSquareType = this.combos['squareType'].filter(y => y.key === x.squareType);
        x.squareTypeNm = filterSquareType[0].value;
      })
    },
    onCellClicked(params) {
      const field = params.colDef.field;
      if(field === 'asAgentNm') {
        this.openModel(params);
      }
    },
    /**
     * 접수/처리 상세 팝업 오픈
     */
    openModel(params) {

      if(params.data.squareType === 'As') {
        this.openModalAs(params.data);
      } else if(params.data.squareType === 'BsMa') {
        const vForm = {
          companyId : this.form.companyId,
          mstType : 'Proc',
          requestId: params.data.squareId
        }
        this.$http.post(_url("/api/workMng/bsMaEdit/selectList"), vForm)
            .then(response => {
              let responseData = response.data;
              responseData.uvwBsMaItemM[0].confirmYn = params.data.confirmYn;
              responseData.uvwBsMaItemM[0].type = 'Square';
              this.openModalBsMa(responseData);
            }).finally(() => {
          this.$store.commit('finish')
        });

      } else if(params.data.squareType === 'SetUp') {
        const vForm = {
          companyId : this.form.companyId,
          requestId: params.data.squareId,
          asAgentId : params.data.asAgentId,
          processTime : ''
        }
        this.$http.post(_url("/api/agent/InstallAgnet/detail/item"), vForm)
            .then(response => {
              response.data.modelSetupSelItem1[0].type = (params.data.squareType === "SetUp" || params.data.squareType === "BsMa") ? "Square" : '';
              this.openModalSetup(response.data);
            }).finally(() => {
          this.$store.commit('finish')
        });
      }
    },
    /**
     * AS 상세 팝업(As) 오픈
     */
    openModalAs(param) {

      let vm = this;
      this.$modal.open({
        width: 800,
        component: ReceptionModal,
        parent: this,
        props: {
          data: {
            asId: param.squareId,
            custId: param.custId,
            sortType: '',
            popHeadInfo: {}, //this.custParam.popHeadInfo,
            //reqDt: this.$moment('20230101').format('YYYY-MM-DD'),
            recptDt: this.$moment(param.callDt).format('YYYY-MM-DD'),
            procsDt: this.$moment(param.procDt).format('YYYY-MM-DD'),
            menuGubun : 'CalculationListModal'
          }
        },
        events: {
          close(data) {
            console.log('close', data);
          },
        }
      });
    },

    /**
     * BS/MA 상세 팝업(BsMa) 오픈
     */
    openModalBsMa(param) {
      this.$modal.open({
        width: 800,
        component: BsMaTreat,
        parent: this,
        props: {
          data: param
        },
        events: {
          close(data) {
          },
        }
      });
    },
    /**
     * 설치 상세 팝업(Setup) 오픈
     */
    openModalSetup(param) {
      console.log('param', param)
      let vm = this;
      this.$modal.open({
        width: 800,
        component: InstallTreat,
        parent: this,
        props: {
          data: param
        },
        events: {
          close(data) {
          },
          goOpen(){
            vm.goOpen();
          }
        }
      });
    },

    /**
     * grid 내에 체크박스 전체 체크 함수
     * @param {*} field 
     * @param {*} checked 
    */
    allCheckEvnet(field, checked) {
      return this.rowData = this.rowData.map(x => {
          x[field] = checked ? 'Y' : 'N';
          return x;
      })
    },
  },
}

</script>

<style lang="scss" scoped>
.modal-card {
  width: 970px;
}

.display-area {
  :global(img) {
    width: 100%;
  }
}

.btn-space {
  margin-right: 4px;
}
</style>